<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card class="elevation-12 mx-auto" max-width="400">
            <v-toolbar color="primary" dark height="56px">
              <v-toolbar-title>
                学校信息管理
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-form v-model="valid" ref="form">
                <v-text-field
                  v-model="username"
                  label="用户名"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  :rules="nameRules"
                  @keyup.enter="login"
                />
                <v-text-field
                  v-model="password"
                  id="password"
                  label="密码"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  :rules="passRules"
                  @keyup.enter="login"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary" :disabled="!valid" :loading="waiting" @click.stop="login">登录</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-footer color="primary" app>
      <v-spacer/>
      <span class="white--text">@北京新中新诚通信息技术股份有限公司 版权所有 软APP备1102882号 <a href='https://beian.miit.gov.cn' target="_blank" style='text-decoration:none;color:#fff;'>黑ICP备08101720号-12</a>网络安全等级保护备案号 11010699354-21001 软著登字第7834899号 软著登字第7841871号{{year}}</span>
      <v-spacer/>
    </v-footer>
  </v-main>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'

export default {
  name: 'Home',
  data () {
    return {
      valid: false,
      waiting: false,
      username: '',
      password: '',
      nameRules: [
        v => !!v || '用户名不能为空',
        v => v.length >= 5 || '用户名太短'
      ],
      passRules: [
        v => !!v || '密码不能为空',
        v => v.length >= 5 || '密码太短'
      ],
      autoRedirect: true
    }
  },
  computed: {
    identity () {
      return this.$store.state.identity
    }
  },
  watch: {
    identity (newValue, oldValue) {
      if (newValue && !oldValue && this.autoRedirect) {
        this.$emit('alert', {
          msg: '已登录，1秒后跳转',
          type: 'success'
        })
        setTimeout(() => {
          this.$router.push({ name: 'Main' })
            .catch(() => {
            })
        }, 1000)
      }
    }
  },
  created () {
    // 检查 Token 是否有效
    this.$store.dispatch('getIdentity')
  },
  methods: {
    login () {
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }
      this.waiting = true
      const request = buildAxios()
      request.post('auth/login', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          this.autoRedirect = false
          this.$store.commit('updateToken', res.data.data.token)
          this.$emit('alert', {
            msg: '登录成功！',
            type: 'success'
          })
          this.$router.push({ name: 'Main' })
            .catch(() => {
            })
          this.$store.dispatch('getPlatType')
        })
        .catch(reason => {
          this.password = ''
          this.waiting = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    }
  }
}
</script>
